import { useEffect } from "react"
import { sendPulseEvent } from "../../services/dru-id/pulse.client";

export default function PulseAnalytics({eventName, additionalInfo}) {
  useEffect(()=>{
    let standarData = {
      "objectDisplayName": additionalInfo.objectDisplayName,
      "targetDisplayName": additionalInfo.targetDisplayName,
      "originDisplayName": additionalInfo.originDisplayName,
      "slug": additionalInfo.slug,
    };

    additionalInfo.standarData = standarData.objectDisplayName;
    additionalInfo.targetDisplayName = standarData.targetDisplayName;
    additionalInfo.targetDisplayName = standarData.targetDisplayName;
    additionalInfo.originDisplayName = standarData.originDisplayName;
    additionalInfo.slug = standarData.slug;

    sendPulseEvent(eventName, additionalInfo);
  }, [])
  return (<></>)
}